import React from 'react'
import ItemSelectableSimple from '../ItemSelectable/ItemSelectableSimple'

const AccessBuildings = ({ accessBuildings, selectBuilding }) => {

    return (
        <div className='d-flex flex-column gap-3'>
            {
                accessBuildings.map((accessBuilding, idx) =>
                    <ItemSelectableSimple key={idx} onClick={() => selectBuilding(accessBuilding)}>
                        {accessBuilding.buildingDescription}
                    </ItemSelectableSimple>
                )
            }
        </div>
    )
}

export default AccessBuildings